<template>
  <div v-if="loaded">
    <sc-panel-navigator @update="e=>$refs.productList.updateOrAppendRow(e)" :drawerWidth="400">
      <el-card>
        <el-row slot="header" class="clearfix">
          <ctk-dater
            range
            v-model="bookingRange"
            display-format="dd/MM/yyyy"
            export-format="DD/MM/YYYY"
          ></ctk-dater>
          <s-remote-select
            dark
            style="width:100%"
            :extraQueryParams="{mode:'select',context:'sapplier'}"
            v-model="tripselect"
            class-model="pricerules"
            query-prop="q"
            label-prop="name"
            placeholder="Search for package"
          ></s-remote-select>
        </el-row>
        <!-- <el-row slot="header" class="clearfix">
          <el-col :span="24">
            <s-remote-select
              style="width:100%"
              :extraQueryParams="{mode:'select',connect:'bookings'}"
              v-model="productselect"
              class-model="pricerules"
              query-prop="q"
              label-prop="title"
              placeholder="Search for servise"
            ></s-remote-select>
          </el-col>
        </el-row>-->
        <div>
          <s-table
            ref="productList"
            v-if="bookingRange.length"
            :colDefinitions="colProductDefinitions"
            modx-processor="pricerules/getlist"
            :r-query="qTrips"
            @cell-clicked="goToBookings"
          ></s-table>
        </div>
      </el-card>
    </sc-panel-navigator>
  </div>
</template>


<script>
import { mapActions, mapGetters } from "vuex";
import _ from "lodash";
import * as dateHelper from "date-fns";
import * as api from "~/api/resource";

import printHtml from "~/mixins/printHtml";

export default {
  mixins: [printHtml],
  data() {
    return {
      printData: null,
      printReady: false,
      loaded: false,
      timelineView: false,
      page: 1,
      productselect: null,
      bookingRange: [],
      tripselect: null,
      cols: {},
      dateFormat: "DD/MM/YY"
    };
  },
  watch: {
    bookingRange: {
      handler(v) {
        var q = { query: null };
        if (this.bookingRange && this.bookingRange.length)
          q.query = {
            range:
              this.bookingRange[0] +
              (this.bookingRange[1] ? "-" + this.bookingRange[1] : "")
          };
        else return;

        // else q["query"] = null;

        this.$router.replace(q);
      },
      deep: true
    },
    tripselect(v, oldv) {
      if (v == oldv) return;

      var nq = { ...this.$route.query, tripselect: v };
      _log_("the rs tripselect", nq);

      this.$router.replace({ query: nq });
    }
  },
  methods: {
    goToBookings(data) {
      _log_("the rs///", data);
      var q = {
        name: "bookingsForProduct",
        params: { productid: data.row.id },
        query: this.$route.query
      };
      this.$router.replace(q);
    }
  },
  async mounted() {
    this.loaded = true;
    //
  },
  computed: {
    workingKind() {
      if (!this.$route.params.kind) {
        console.error("Route corrupted, no trip kind specified");
        return;
      }
      return this.$route.params.kind.toUpperCase();
    },
    ...mapGetters({
      rooms: "hotelinfo/rooms"
    }),
    // qBookings() {
    //   return { "bookingRange[]": bookingRange, productselect: productselect };
    // },
    qTrips() {
      _log_(">>Q>>", this.productselect);
      var q = {
        mode: "select",
        context: "sapplier",
        connect: "bookings",
        sum: "pax",
        productid: this.$route.query.tripselect,
        range:
          (this.bookingRange[0] ? this.bookingRange[0] : "") +
          "-" +
          (this.bookingRange[1] ? this.bookingRange[1] : "")
      };

      return q;
    },
    colProductDefinitions() {
      var rw = "580px";
      if (window.innerWidth < 500) rw = "180px";
      if (window.innerWidth < 700) rw = "280px";
      if (window.innerWidth < 1000) rw = "380px";
      return [
        // {
        //   prop: "paymentStatus",
        //   width: "120px",
        //   label: "Πληρωμή",
        //   displayClass: "el-tag el-tag--info",
        //   component: {
        //     is: "v-payment"
        //   }
        // },

        // {
        //   prop: "time",
        //   width: "",
        //   label: "Date",
        //   formatter: function(val, colDefs, row, vm) {
        //     // _log_(">>>>" + val, row);
        //     return vm.formatDate(val);
        //   }
        // },
        { prop: "name", width: "", label: "Servise" },
        // {
        //   prop: "timetime",
        //   width: "",
        //   label: "Time",
        //   formatter: function(val, colDefs, row, vm) {
        //     _log_(">>>>" + val, row);
        //     return vm.formatUnxTime(row.time, true);
        //   }
        // },
        {
          prop: "pax",
          width: 75,
          label: "PAX",
          formatter: function(val, cols, row) {
            return row.adultspax;
            return (
              (val ? val : 0) +
              "(" +
              (row.adultspax ? row.adultspax : 0) +
              "/" +
              (row.kidspax ? row.kidspax : 0) +
              "/" +
              (row.freepax ? row.freepax : 0) +
              ")"
            );
          }
        }
        // {
        //   prop: "roomsF",
        //   width: rw,
        //   label: "Κράτηση",
        //   displayClass: "el-tag el-tag--info",
        //   component: {
        //     is: "v-rooms"
        //   }
        // }
      ];
    }
  }
};
</script>

<style>
.search.x-row {
  align-items: flex-start;
}
.has-more {
  color: red;
  font-weight: 700;
}
</style>
